import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTitleBar } from "@/context/TitleBarProvider";
import { Server, Trash2, Unplug, Plus, ExternalLink } from "lucide-react";
import { useAutomationServersQuery } from "@/hooks/useAutomationServersQuery";
import { DeleteAutomationServerModal } from "@/components/automation-server/DeleteAutomationServerModal";
import { WorkspacesListSection } from "@/components/workspaces/WorkspacesListSection";
import { CreateWorkspaceModal } from "@/components/workspaces/CreateWorkspaceModal";

const AutomationServerDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { data: automationServersData } = useAutomationServersQuery();
  const { setTitle, setIcon, setButtons } = useTitleBar();
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const server = automationServersData?.pages.flatMap((page) => page.results).find(
    (server) => server.automation_server_id === id,
  );

  useEffect(() => {
    setTitle(`${server?.name} workspaces`);
    setIcon(<Server size={24} />);
    setButtons(
      <>
        {server?.bailey_url && (
          <a href={server.bailey_url} target="_blank" rel="noopener noreferrer">
            <Button variant="outline">
              <ExternalLink className="h-4 w-4 mr-1" />
              Bailey console
            </Button>
          </a>
        )}
        <Button onClick={() => setCreateModalOpen(true)}>
          <Plus className="h-4 w-4 mr-1" />
          Create Workspace
        </Button>
        <DeleteAutomationServerModal
          serverName={server?.name ?? ""}
          serverId={server?.automation_server_id ?? ""}
          isCloud={server?.server_type === "hetzner"}
        >
          {server?.server_type === "hetzner" ? (
            <Button variant="destructive">
              <Trash2 className="h-4 w-4 mr-1" />
              Delete server
            </Button>
          ) : (
            <Button variant="outline">
              <Unplug className="h-4 w-4 mr-1" />
              Disconnect server
            </Button>
          )}
        </DeleteAutomationServerModal>
      </>
    );
  }, [server, setTitle, setButtons, setIcon]);

  if (!server) {
    return <div>Automation server not found</div>;
  }

  return (
    <div>
      <CreateWorkspaceModal
        open={createModalOpen}
        onOpenChange={setCreateModalOpen}
        automationServerId={id ?? ""}
        onSuccess={() => {
          // Refresh workspaces list
          window.location.reload();
        }}
      />
      <WorkspacesListSection automationServerId={id} />
    </div>
  );
}

export default AutomationServerDetailPage;